/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextBulletChecklistIcon16Light = forwardRef('TextBulletChecklistIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5.604 2.354a.5.5 0 1 0-.708-.708L2.5 4.043l-.896-.897a.5.5 0 1 0-.708.708l.897.896a1 1 0 0 0 1.414 0l2.397-2.396Z" }),
        React.createElement("path", { d: "M13.5 4h-6a.5.5 0 0 1 0-1h6a.5.5 0 0 1 0 1Z" }),
        React.createElement("path", { d: "M7.5 7a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6Z" }),
        React.createElement("path", { d: "M7.5 11a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6Z" }),
        React.createElement("path", { d: "M5.604 5.896a.5.5 0 0 1 0 .708L3.207 9a1 1 0 0 1-1.414 0l-.897-.896a.5.5 0 1 1 .708-.708l.896.897 2.396-2.397a.5.5 0 0 1 .708 0Z" }),
        React.createElement("path", { d: "M5.604 10.854a.5.5 0 0 0-.708-.708L2.5 12.543l-.896-.897a.5.5 0 0 0-.708.708l.897.896a1 1 0 0 0 1.414 0l2.397-2.396Z" })));
});
